class MenuHoverManager {
  constructor({ closeDelayMs = 180, onOpen, onClose } = {}) {
    this.closeDelayMs = closeDelayMs;
    this.onOpen = onOpen;
    this.onClose = onClose;
    this.closeTimer = null;
    this.openId = 0;
  }

  enter(id) {
    this.clearCloseTimer();
    this.openId = id;

    if (this.onOpen) {
      this.onOpen(id);
    }
  }

  leave() {
    this.clearCloseTimer();
    this.closeTimer = setTimeout(() => {
      this.openId = 0;
      this.closeTimer = null;

      if (this.onClose) {
        this.onClose();
      }
    }, this.closeDelayMs);
  }

  closeNow() {
    this.clearCloseTimer();
    this.openId = 0;

    if (this.onClose) {
      this.onClose();
    }
  }

  clearCloseTimer() {
    if (this.closeTimer) {
      clearTimeout(this.closeTimer);
      this.closeTimer = null;
    }
  }
}

export default MenuHoverManager;
